










import Vue from 'vue';
import { StepData } from '@/src/components/processes/mp-wizard.vue';
import oneSchema from './schema/1.schema';
import twoSchema from './schema/2.schema';
import threeSchema from './schema/3.schema';
import OnlinePaymentResourceViewModel from '@/src/services/viewModel/resource/OnlinePaymentResourceViewModel';

export default Vue.extend({
  auth: true,
  hasBackButton: true,
  data: () => ({
    memberShip: '',
    title: 'page.invoice.title.onlinePayment',
    model: OnlinePaymentResourceViewModel,
    steps: [
      {
        breadcrumb: 'page.invoice.label.stepTitles.1',
        component: () => import('./onlinePayment1.vue'),
        schema: oneSchema,
        sendData: false,
      },
      {
        breadcrumb: 'page.invoice.label.stepTitles.2',
        component: () => import('./onlinePayment2.vue'),
        schema: twoSchema,
        sendData: true,
      },
      {
        breadcrumb: 'page.invoice.label.stepTitles.3',
        component: () => import('./onlinePayment3.vue'),
        schema: threeSchema,
        sendData: false,
        disablePreviousSteps: true,
        clearProgressOnMounted: true,
      },
    ] as StepData[],
  }),
  computed: {
    contactId() {
      return this.$route.params.id;
    },
  },
  methods: {
    async serviceFunction(wizardData: OnlinePaymentResourceViewModel) {
      await this.$service.api.invoices.payMyInvoice(wizardData);
    },
    initializeData() {
      const initializedModel = new OnlinePaymentResourceViewModel().fromDTO({
        items: [],
        onlinePayment: {},
      } as Parameters<OnlinePaymentResourceViewModel['fromDTO']>[0]);
      return initializedModel;
    },
  },
});
